module.exports = __webpack_public_path__ + "static/media/image_9.784d4a96.png";